import React from 'react';
import '../styles.css';
import '../popup.css';
import '../try.css';
import '../App.css';
import { Component } from 'react';
// import NavLink from "./NavLink";
import { Link, NavLink } from 'react-router-dom';
import DarkMode from "./DarkMode";

class Nav extends Component {
    state = {
        isactive: false,
        isCheck: false,
        isScroll: false
    }

    render() {
        return (
            <>
                <div className="nav-container" id="page-top" >
                    <nav id="page-top" >
                        <div className="nav-container-div" style={{ margin: "auto", maxWidth: "1200px" }}>
                            <label className="logo" translate="no"><Link className="logo-link" to="/">Zuber Dunge</Link></label>

                            <ul className={"menu-list " + (this.state.isactive ? " show" : "")}>


                                <li>  <NavLink exact to="/" activeClassName="active"  >Home</NavLink></li>
                                <li><NavLink to="./Projects" activeClassName="active">Projects</NavLink></li>
                                <li><NavLink to="./Blogs" activeClassName="active" >Blogs</NavLink></li>
                                {/* <li><NavLink to="./Resume" activeClassName="active">Resume</NavLink></li> */}
                                <li><NavLink to="./Contact" activeClassName="active" >Say Hello</NavLink></li>
                                <li className="toggleicon"> <DarkMode /></li>
                            </ul>


                            <label id="icon" onClick={() => {
                                if (this.state.isactive) {
                                    this.setState({ isactive: false })
                                } else {
                                    this.setState({ isactive: true })
                                }
                            }}>  <div className={"nav-icon " + (this.state.isactive ? " nav-icon-hover" : "")}>
                                    <div></div>
                                </div></label>
                        </div>
                    </nav>
                </div >








            </>
        );
    }
}

export default Nav;